import { WhiteLabel } from '@api/white-label'

const INITIAL_WHITE_LABEL_DATA: WhiteLabel = {
  filter: {
    blockDropdownLabel: 'Building',
    levelDropdownLabel: 'Level',
    precinctDropdownLabel: 'Precinct',
    stageDropdownLabel: 'Stage',
    toggleText: 'Only show available residences',
  },
  shortlist: {
    qrCodeScanLabel: 'Scan the QR code to save your shortlist',
    includeLabel: 'INCLUDE',
    agentLabel: 'AGENT',
  },
  propertySidePanel: {
    packageListTitle: 'FLOORPLAN',
    floorplanOption: 'FLOORPLAN OPTION',
    facade: 'FACADE',
    facadeColor: 'FACADE COLOUR',
    internalTheme: 'INTERNAL THEME',
    internalColorScheme: 'INTERNAL COLOUR SCHEME',
    levelStagePrefix: 'Level',
  },
  propertyView: {
    panoramicButtonTitle: 'Virtual Tour',
    loadExternalLinkButtonTitle: 'Load External Link',
    closeExternalLinkButtonTitle: 'Close External Link',
  },
  floorStageView: {
    panoramicButtonTitle: 'Virtual Tour',
  },
}

const mapWhiteLabelsWithDefaults = (
  whiteLabels: WhiteLabel,
  isHouseAndLandProject?: boolean
): WhiteLabel => {
  const mapObject = <T>(
    initialValues: T,
    payload: Partial<T> | undefined
  ): T => {
    if (typeof initialValues !== 'object' || initialValues === null) {
      return (payload as T) ?? initialValues
    }

    return Object.keys(initialValues).reduce((acc, key) => {
      const keyTyped = key as keyof T
      const templateValue = initialValues[keyTyped]
      const sourceValue = payload?.[keyTyped]

      if (typeof templateValue === 'object' && templateValue !== null) {
        acc[keyTyped] = mapObject(
          templateValue,
          sourceValue as Partial<typeof templateValue> | undefined
        )
      } else {
        acc[keyTyped] = sourceValue != null ? sourceValue : templateValue
      }

      return acc
    }, {} as T)
  }

  const defaultWhiteLabel = INITIAL_WHITE_LABEL_DATA

  if (isHouseAndLandProject) {
    defaultWhiteLabel.propertySidePanel.levelStagePrefix = 'Stage'
    defaultWhiteLabel.filter.toggleText = 'Only show available lots'
  }

  return mapObject(defaultWhiteLabel, whiteLabels)
}

export default mapWhiteLabelsWithDefaults
